module.exports = __webpack_public_path__ + "static/media/witchcraft_academy.netent.356c3264.jpeg";